
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.204 8.794a2.72 2.72 0 00-3.843 0L8.201 19.932a.686.686 0 00-.201.486v2.896c0 .379.307.686.686.686h2.844a.686.686 0 00.485-.2l11.189-11.167a2.71 2.71 0 000-3.839zm-2.874.971a1.349 1.349 0 011.905 0 1.34 1.34 0 010 1.897l-.735.733-1.902-1.899.732-.731zm-1.703 1.7l1.902 1.899-9.283 9.265H9.371v-1.927l9.256-9.237z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16zm-1.5 0c0 8.008-6.492 14.5-14.5 14.5S1.5 24.008 1.5 16 7.992 1.5 16 1.5 30.5 7.992 30.5 16z","fill":"#A4A8C0"}})])
          )
        }
      }
    